// Product data for BUDOBET.PL — real values from supplier Excel (INFO.xlsx)
// Each variant has rolls per pallet = 24
// areaPerRoll = m² per single roll (uwzględnia "dwie maty w rolce" dla 50mm 039/035)

const ROLL_WIDTH_M = 1.2;
export const ROLLS_PER_PALLET = 24;

export const PRODUCTS = [
  {
    id: "033",
    code: "0,033",
    lambda: 0.033,
    name: "Wełna Szklana 0,033",
    tagline: "Najwyższa efektywność termiczna",
    description:
      "Premium wełna mineralna szklana o najniższym współczynniku przewodzenia ciepła. Idealna tam, gdzie liczy się każdy milimetr grubości izolacji – modernizacje dachów skośnych, ścianki kolankowe, stropy drewniane, konstrukcje szkieletowe.",
    accentClass: "text-red-600",
    bgAccent: "bg-red-600",
    indexes: "10052114; 10052123; 10052124; 10052125",
    image:
      "https://tytan-cdn.tytan.com/uploads/sites/53/2026/05/TP20WEC581NA20SZKLANA2002C0332046518V01_r-1.png",
    pdfUrl:
      "https://customer-assets.emergentagent.com/job_mineral-wool-store/artifacts/x2my2mbg_We%C5%82na%20szklana%200%2C033.pdf",
    variants: [
      { thickness: 50, width: ROLL_WIDTH_M, length: 9.0, areaPerRoll: 10.8 },
      { thickness: 100, width: ROLL_WIDTH_M, length: 4.5, areaPerRoll: 5.4 },
      { thickness: 150, width: ROLL_WIDTH_M, length: 3.0, areaPerRoll: 3.6 },
      { thickness: 200, width: ROLL_WIDTH_M, length: 2.4, areaPerRoll: 2.88 },
    ],
    fireClass: "A1",
    badge: "PREMIUM",
  },
  {
    id: "035",
    code: "0,035",
    lambda: 0.035,
    name: "Wełna Szklana 0,035",
    tagline: "Optymalna cena do parametrów",
    description:
      "Uniwersalna, elastyczna wełna mineralna szklana o bardzo dobrych właściwościach termoizolacyjnych. Polecana do typowych zastosowań – dachów skośnych, ścian działowych, sufitów podwieszanych i podłóg na legarach.",
    accentClass: "text-zinc-900",
    bgAccent: "bg-zinc-900",
    indexes: "10052126; 10052121; 10052127; 1005212",
    image:
      "https://tytan-cdn.tytan.com/uploads/sites/53/2026/05/WEC581NA20SZKLANA2002C0352046517V01_r-1.png",
    pdfUrl:
      "https://customer-assets.emergentagent.com/job_mineral-wool-store/artifacts/qijaoodf_We%C5%82na%20szklana%200%2C034%2035-50%20100R.pdf",
    variants: [
      // 50mm — dwie maty w rolce, 2×6m
      { thickness: 50, width: ROLL_WIDTH_M, length: 12.0, areaPerRoll: 14.4 },
      { thickness: 100, width: ROLL_WIDTH_M, length: 6.0, areaPerRoll: 7.2 },
      { thickness: 150, width: ROLL_WIDTH_M, length: 4.0, areaPerRoll: 4.8 },
      { thickness: 200, width: ROLL_WIDTH_M, length: 3.0, areaPerRoll: 3.6 },
    ],
    fireClass: "A1",
    badge: "BESTSELLER",
  },
  {
    id: "039",
    code: "0,039",
    lambda: 0.039,
    name: "Wełna Szklana 0,039",
    tagline: "Sprawdzony standard",
    description:
      "Uniwersalna, elastyczna wełna mineralna szklana do izolacji cieplnej i akustycznej. Dedykowana do dachów skośnych, ścian działowych, sufitów podwieszanych oraz podłóg na legarach.",
    accentClass: "text-zinc-700",
    bgAccent: "bg-zinc-700",
    indexes: "10052133; 10052137; 10052139; 10052140",
    image:
      "https://tytan-cdn.tytan.com/uploads/sites/53/2026/04/TP20WEC581NA20SZKLANA2002C039202046516V01_r-2.png",
    pdfUrl:
      "https://customer-assets.emergentagent.com/job_mineral-wool-store/artifacts/xgrout14_We%C5%82na%20szklana%200%2C039.pdf",
    variants: [
      // 50mm — dwie maty w rolce, 2×9m
      { thickness: 50, width: ROLL_WIDTH_M, length: 18.0, areaPerRoll: 21.6 },
      { thickness: 100, width: ROLL_WIDTH_M, length: 9.0, areaPerRoll: 10.8 },
      { thickness: 150, width: ROLL_WIDTH_M, length: 6.0, areaPerRoll: 7.2 },
      { thickness: 200, width: ROLL_WIDTH_M, length: 4.5, areaPerRoll: 5.4 },
    ],
    fireClass: "A1",
    badge: "EKONOMICZNA",
  },
];

export const MEDIA = {
  // Hero: worker installing pink mineral wool insulation between studs — exact product theme
  hero: "https://images.pexels.com/photos/6124239/pexels-photo-6124239.jpeg?auto=compress&cs=tinysrgb&w=2400&q=80",
  logo: "https://static.prod-images.emergentagent.com/jobs/8cc9b4a0-d33c-4828-9e11-2608211883f2/images/c845edeb459c4cfbb8e6f234f672b7dcdba8293f447a152f082360e4677d76c7.png",
  // Applications: workers on rooftop with colorful insulation materials
  worker:
    "https://images.pexels.com/photos/5511085/pexels-photo-5511085.jpeg?auto=compress&cs=tinysrgb&w=1600&q=80",
};

export const COMPANY = {
  name: "BUDOBET.PL",
  email: "info@budobet.pl",
  phone: "+48 796 021 743",
  freeDeliveryFromPallets: 4,
};
